/**
 * Microsoft Clarity loader.
 * Heatmaps + session recordings, free, no GDPR/PD issues for RU.
 * Project ID is loaded from Vite env var VITE_CLARITY_PROJECT_ID.
 * Set it in .env or leave empty to disable.
 */

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

const DEFAULT_CLARITY_ID = "wr1ylq06fj";
let loaded = false;

export function loadClarity(): void {
  if (loaded || typeof window === "undefined") return;
  // Skip if inline script already initialized Clarity
  if (window.clarity) {
    loaded = true;
    return;
  }
  const projectId =
    (import.meta.env.VITE_CLARITY_PROJECT_ID as string | undefined) ||
    DEFAULT_CLARITY_ID;
  loaded = true;

  // Standard Clarity snippet
  (function (c: any, l: Document, a: string, r: string, i: string) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = "https://www.clarity.ms/tag/" + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode?.insertBefore(t, y);
  })(window, document, "clarity", "script", projectId);
}

/** Tag a Clarity session with custom event/identifier (for funnel analysis) */
export function clarityEvent(name: string): void {
  try {
    window.clarity?.("event", name);
  } catch {}
}

export function claritySet(key: string, value: string): void {
  try {
    window.clarity?.("set", key, value);
  } catch {}
}
